/**
 * this is the core wrapper for the ABTests API,
 * you should pass here the tests you got from `window` or backend call
 */
export function ABTests(tests: FeatureTests) {
  return {
    /**
     * if the test doesn't exists it will default to inactive/control
     */
    get(name: string) {
      return {
        _source: tests[name] ?? { active: false, variant: "control" },
        /**
         * Is the A/B Test is ON/OFF as a whole.
         */
        get isActive() {
          return this._source.active;
        },
        /**
         * will return false if this tests is using default values
         */
        get exists() {
          return Boolean(tests[name]);
        },
        /**
          * Is the user in the control or compare group
          */
        isVariant(variant: ABTest['variant']) {
          return this._source.variant === variant;
        },
        /** alias for `isVariant("control")`*/
        get isControl() {
          return this.isVariant("control");
        },
        /** alias for `isVariant("compare")`*/
        get isCompare() {
          return this.isVariant("compare");
        },
        get shouldSendTracking() {
          return this.isCompare && this.isActive;
        }
      };
    }
  };
}

export function getABTests() {
  const ab_tests = ABTests(window.feature_tests ?? {});
  return ab_tests;
}

export type ABTest = { active: boolean, variant: "control" | "compare" };
export type FeatureTests = Record<string, ABTest>;
